/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_End_ActionInputs */

const en_blog_end_action = /** @type {(inputs: Blog_End_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a discovery call`)
};

const lv_blog_end_action = /** @type {(inputs: Blog_End_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieteikt iepazīšanās sarunu`)
};

/**
* | output |
* | --- |
* | "Book a discovery call" |
*
* @param {Blog_End_ActionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_end_action = /** @type {((inputs?: Blog_End_ActionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_End_ActionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_end_action(inputs)
	return en_blog_end_action(inputs)
});